import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Bell } from "lucide-react";

export default function Notifications() {
    const [rows, setRows] = useState([]);
    useEffect(() => {
        (async () => { try { const { data } = await api.get("/notifications"); setRows(data); } catch {} })();
    }, []);
    return (
        <div className="space-y-6" data-testid="notifications-page">
            <div>
                <p className="text-[10px] uppercase tracking-[0.28em] text-komma-gold">Inbox</p>
                <h1 className="font-serif text-3xl text-komma-navy">Notifications</h1>
            </div>
            <div className="komma-card divide-y divide-gray-100">
                {rows.map((n) => (
                    <div key={n.id} className="p-5 flex gap-4 items-start" data-testid={`notif-${n.id}`}>
                        <div className="h-9 w-9 rounded-full bg-komma-gold/15 text-komma-gold-dark flex items-center justify-center">
                            <Bell size={16} />
                        </div>
                        <div className="flex-1">
                            <p className="text-sm text-komma-navy">{n.title}</p>
                            <p className="text-[10px] uppercase tracking-widest text-gray-400 mt-1">{n.role_target} · {new Date(n.created_at).toLocaleString()}</p>
                        </div>
                    </div>
                ))}
                {rows.length === 0 && <p className="p-10 text-center text-gray-500">No notifications.</p>}
            </div>
        </div>
    );
}
